// extracted by mini-css-extract-plugin
export default {"container":"CountryExplorationSubmission_container__1U0yU"};